// Resolve the public surface before importing authentication, app state or telemetry.
// This must remain the only entry imported by index.html.
if (window.location.pathname === '/document-upload') {
  void import('./document-upload/entry');
} else {
  void import('./authenticated-entry');
}

export {};
